export const defaultTimeZone = 'Central Time (US & Canada)'
export const centralTimeDayJs = 'America/Chicago'
export const mountainStandardTime = 'America/Denver'

export const timezoneMapping: { [key: string]: string } = {
  'America/New_York': 'America/Eastern (New York)',
  'America/Detroit': 'America/Eastern (Detroit)',
  'America/Indiana/Indianapolis': 'America/Eastern (Indianapolis)',
  'America/Chicago': 'America/Central',
  'America/Denver': 'America/Mountain (Denver)',
  'America/Phoenix': 'America/Mountain (Phoenix)', // Arizona does not observe DST
  'America/Los_Angeles': 'America/Pacific',
  'America/Anchorage': 'America/Alaska',
  'America/Adak': 'America/Hawaii–Aleutian (Adak)',
  'Pacific/Honolulu': 'America/Hawaii–Aleutian (Honolulu)',
}
